class ManageDialog extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.modalToOpen = document.querySelector(this.getAttribute('data-open'));
    this.button.onclick = () => this.handleButtonClick();
  }

  
  handleButtonClick() {
    if (this.modalToOpen.hasAttribute('open')) {
      this.modalToOpen.hide();
    } else {
      this.modalToOpen.show(this.button);
    }
  }
}

customElements.define('manage-dialog', ManageDialog);



class notifyMePopup extends ModalDialog {
  constructor() {
    super();
    this.productId = this.getAttribute('data-product-id');
    this.form = this.querySelector('form');
    this.email = this.form.querySelector('input[name="contact[email]"]');
    this.acceptPP = this.form.querySelector('input[name="contact[checkPrivacy]"]');
    this.submitBtn = this.form.querySelector('button[type="submit"]');

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.create();
    });

    this.form.addEventListener('input', () => this.check());
  }

  connectedCallback() {
    subscribe(PUB_SUB_EVENTS.variantChange, (data) => this.getOptionsValue(data));
  }

  getOptionsValue({data}) {
    const notifyVariant =  this.querySelector('#notify_variant');
    const optionToSelect = Array.from(notifyVariant.options).find(opt => opt.value == data.variant.id);
    if (optionToSelect) {
      optionToSelect.selected = "selected";
    }
  }

  validateEmail = (email) => {
    const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/;
    return regex.test(email);
  };

  showErrorBtn = (submitBtn) => {
    submitBtn.classList.add('submit__error');
    submitBtn.innerHTML = window.errorStrings.formInvalid;
  };

  removeErrorBtn = (submitBtn) => {
    submitBtn.classList.remove('submit__error');
  };

  check() {
    if (this.validateEmail(this.email.value) && this.acceptPP.checked) {
      this.submitBtn.removeAttribute("disabled");
    } else {
      this.submitBtn.setAttribute("disabled", '');
    }
  }

  
  async create() {
    const emailValue = this.email.value;
    const notifyVariant =  this.querySelector('#notify_variant');
    const response = await BIS.create(emailValue, notifyVariant.value, this.productId);
    const dataMessageValue = this.submitBtn.getAttribute('data-message');

    if (response.status === 'OK') {
      this.submitBtn.innerHTML = dataMessageValue;
    } else {
      this.submitBtn.innerHTML = response.errors.base[0];
    }
  }
}

customElements.define('notifyme-popup', notifyMePopup);
